export default "__VITE_ASSET__CeP0RRFP__"